import type { FaireProductEntity } from "../../entity_types/product";

export const atc_refined_moma_2: FaireProductEntity = {
  token: "atc_refined_moma_2",
  type: "product",
  name: "Memphis Design Coffee Mugs",
  brandName: "Pozzi Milano",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a9d6fe817244c5e2a616b212d7a516cfcd49a3180e8b94b4a01df31c9ba69c9f.webp",
  priceDollars: 42,
  msrpDollars: 68,
  description: "Italian-designed tableware with Memphis-inspired aesthetic.",
  tags: ["tableware", "drinkware", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
